require('./arrow_drop_down.svg');
require('./chevron_left.svg');
require('./chevron_right.svg');
require('./facebook.svg');
require('./google_plus.svg');
require('./instagram.svg');
require('./linkedin.svg');
require('./pause.svg');
require('./play_arrow.svg');
require('./twitter.svg');
require('./youtube.svg');